<template>
  <div class="mask">
    <div class="userLog">
      <p class="title">日志详情</p>
      <div style="padding:0 4vw;height:66%" >
        <el-table :data="logList" height="100%"
        ref="logList" border header-row-class-name="tableHeader"  row-class-name="tableRow" >
          <el-table-column prop="action_title"  label="操作" width="180px" ></el-table-column>
          <el-table-column prop="content_before"  label="操作前内容" > </el-table-column>
          <el-table-column prop="content_after"  label="操作后内容" ></el-table-column>
          <el-table-column prop="user_name"  label="用户名" width="100px"></el-table-column>
          <el-table-column prop="create_time"  label="时间" width="100px"></el-table-column>
        </el-table>
      </div>
      
      <div class="submitDiv">
        <span class="button btn-add" @click="submit()">关闭</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import {log} from '@/api/manageConfig'
export default {
  data(){
    return{
      id:"",
      logList:[
        {action_admin_name:"",content_before:'',content_after:'',create_time:'',action_title:''}
      ],
      page:1,
      last_page:1
    }
  },
  props:['showLogDetail'],
  watch:{
    showLogDetail:function(n,o){
      if(n){
        this.page = 1
        this.logList =[]
        this.getLog()
      }
    }
  },
  mounted(){
    this.dom = this.$refs.logList.bodyWrapper
    this.dom.addEventListener('scroll', () => {
      // 滚动距离
      let scrollTop = this.dom.scrollTop
      // 变量windowHeight是可视区的高度
      let windowHeight = this.dom.clientHeight || this.dom.clientHeight
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        // 获取到的不是全部数据 当滚动到底部 继续获取新的数据
        if (this.page <= this.last_page) {
          this.page += 1
          this.getLog()
        }else{
          this.$message({message:'没有更多数据',type:'warning'})
        }
      }
    })
  },
  methods:{
    submit(){
      this.$emit('submit')
    },
    getLog(){
      let params ={
        id:this.id,
        page:this.page
      }
      log(params).then(res=>{
        let list = res
        for(let i in list){
          list[i].content_after = this.transform(list[i].content_after)
          list[i].content_before = this.transform(list[i].content_before)
        }
        this.logList = this.logList.concat(list) 
        this.last_page = res.last_page
      })
    },
    transform(target){
      let str = ""
      if(target){
        target = JSON.parse(target)
        let isArray = target instanceof Array;
        if(isArray){
          for (let item in target){
            for(let i in target[item]){
              str+= i + ':' +target[item][i] +','
            }
          }
        }else{
          for(let i in target){
            str+= i + ':' +target[i] +','
          }
        }
      }
      str = str.substring(0,str.length-1)
      return str
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/maskForm.scss';
@import '@/assets/scss/table.scss';
.mask>{
  div.userLog{
    height: 74.8vh;
    width: 80vw;
    min-height: 510px;
    >p.title{
      padding: 2.1vw;
      margin-bottom: 2vh;
    }
    .submitDiv{
      text-align: center;
      padding-top: 2%;
    }
  }
 
}
</style>
